{
  "MACROS": {
    "HEADER": "Macrocomenzi",
    "DESCRIPTION": "A macro is a set of saved actions that help customer service agents easily complete tasks. The agents can define a set of actions like tagging a conversation with a label, sending an email transcript, updating a custom attribute, etc., and they can run these actions in a single click.",
    "LEARN_MORE": "Learn more about macros",
    "HEADER_BTN_TXT": "Adaugă un nou webhook",
    "HEADER_BTN_TXT_SAVE": "Salvarea macrocomenzii",
    "LOADING": "Preluarea macrocomenzilor",
    "ERROR": "Ceva nu a mers bine. Vă rugăm să încercați din nou",
    "ORDER_INFO": "Macrocomenzile vor rula în ordinea în care adăugați acțiunile. Le puteți rearanja trăgându-le de mânerul de lângă fiecare nod.",
    "ADD": {
      "FORM": {
        "NAME": {
          "LABEL": "Numele macrocomenzii",
          "PLACEHOLDER": "Introducerea unui nume pentru macrocomandă",
          "ERROR": "Numele este necesar pentru crearea unei macrocomenzi"
        },
        "ACTIONS": {
          "LABEL": "Actiuni"
        }
      },
      "API": {
        "SUCCESS_MESSAGE": "Macrocomandă adăugată cu succes",
        "ERROR_MESSAGE": "Imposibil de creat macrocomanda, încercați din nou mai târziu"
      }
    },
    "LIST": {
      "404": "Nu s-au găsit macrocomenzi",
      "TABLE_HEADER": {
        "NAME": "Nume",
        "CREATED BY": "Creat de",
        "LAST_UPDATED_BY": "Ultima actualizare de către",
        "VISIBILITY": "Vizibilitate"
      }
    },
    "DELETE": {
      "TOOLTIP": "Ștergerea macrocomenzii",
      "CONFIRM": {
        "MESSAGE": "Sigur doriți să ștergeți ",
        "YES": "Da, șterge",
        "NO": "Nu"
      },
      "API": {
        "SUCCESS_MESSAGE": "Macrocomanda ștearsă cu succes",
        "ERROR_MESSAGE": "A existat o eroare la ștergerea macrocomenzii. Încercați din nou mai târziu"
      }
    },
    "EDIT": {
      "TOOLTIP": "Editarea macrocomenzii",
      "API": {
        "SUCCESS_MESSAGE": "Macrocomenzi actualizate cu succes",
        "ERROR_MESSAGE": "Nu s-a putut actualiza macrocomanda, încercați din nou mai târziu"
      }
    },
    "EDITOR": {
      "START_FLOW": "Flux de pornire",
      "END_FLOW": "Fluxul final",
      "LOADING": "Preluarea macrocomenzii",
      "ADD_BTN_TOOLTIP": "Adăugarea unei acțiuni noi",
      "DELETE_BTN_TOOLTIP": "Ștergere acțiune",
      "VISIBILITY": {
        "LABEL": "Vizibilitatea macrocomenzilor",
        "GLOBAL": {
          "LABEL": "Public",
          "DESCRIPTION": "Această macrocomandă este disponibilă public pentru toți agenții din acest cont."
        },
        "PERSONAL": {
          "LABEL": "Privat",
          "DESCRIPTION": "Această macrocomandă va fi privată pentru tine și nu va fi disponibilă pentru alte persoane."
        }
      }
    },
    "EXECUTE": {
      "BUTTON_TOOLTIP": "Executa",
      "PREVIEW": "Previzualizarea macrocomenzii",
      "EXECUTED_SUCCESSFULLY": "Macrocomandă executată cu succes"
    },
    "ERRORS": {
      "ATTRIBUTE_KEY_REQUIRED": "Attribute key is required",
      "FILTER_OPERATOR_REQUIRED": "Filter operator is required",
      "VALUE_REQUIRED": "Este necesară o valoare validă",
      "VALUE_MUST_BE_BETWEEN_0_AND_998": "Valoarea trebuie să fie între 0 și 998",
      "ACTION_PARAMETERS_REQUIRED": "Action parameters are required",
      "ATLEAST_ONE_CONDITION_REQUIRED": "At least one condition is required",
      "ATLEAST_ONE_ACTION_REQUIRED": "At least one action is required",
      "VALUE_MUST_BE_BETWEEN_1_AND_998": "Value must be between 1 and 998"
    },
    "ACTIONS": {
      "ASSIGN_TEAM": "Atribuie o echipă",
      "ASSIGN_AGENT": "Atribuie un agent",
      "ADD_LABEL": "Adaugă o etichetă",
      "REMOVE_LABEL": "Elimină o etichetă",
      "REMOVE_ASSIGNED_TEAM": "Elimină echipa atribuită",
      "SEND_EMAIL_TRANSCRIPT": "Trimite transcrierea pe email",
      "MUTE_CONVERSATION": "Dezactivează notificările pentru conversație",
      "SNOOZE_CONVERSATION": "Amână conversația",
      "RESOLVE_CONVERSATION": "Rezolvă conversația",
      "SEND_ATTACHMENT": "Trimite atașament",
      "SEND_MESSAGE": "Trimite un mesaj",
      "CHANGE_PRIORITY": "Schimbă prioritatea",
      "ADD_PRIVATE_NOTE": "Adaugă o notă privată",
      "SEND_WEBHOOK_EVENT": "Trimite eveniment webhook"
    },
    "ACTION_VALUES": {
      "SELF": "Eu"
    }
  }
}
